// extracted by mini-css-extract-plugin
export default {"container":"Card_container__g8yyr","capa":"Card_capa__jgjI3","favoritar":"Card_favoritar__GCYtY","link":"Card_link__a-YeT","titulo":"Card_titulo__ywPAA"};